import moment from "moment";
import { DateTimeProvider } from "../../Services/DateTimeProvider";
import { Div, HandlersCollection } from "@tblabs/truffle";
import { CalendarEntry } from "./CalendarEntry";
import { MonthSwitcher } from "./MonthSwitcher";


export class Calendar extends Div
{
    private grid = new Div("calendar-grid");
    private monthSwitcher = new MonthSwitcher(this.entries[0]?.Date);

    public get Switcher(): MonthSwitcher
    {
        return this.monthSwitcher;
    }

    private onDayClick = new HandlersCollection<(date: Date) => void>();
    public OnDayClick(handler: (date: Date) => void)
    {
        this.onDayClick.Add(handler);

        return this;
    }

    constructor(private entries: CalendarEntry[])
    {
        super("calendar");

        this.monthSwitcher.OnChange(v => this.Refresh())

        const header = new Div("calendar-header")
            .Append(this.monthSwitcher)

        const daysHeader = new Div("calendar-days")
            .Append(
                ...["Pn", "Wt", "Śr", "Cz", "Pt", "So", "Nd"]
                    .map(day =>
                        new Div("day-name").Text(day))
            )

        this.Append(
            header,
            daysHeader,
            this.grid
        )

        this.Refresh();
    }

    private Refresh()
    {
        this.grid.Clear();

        // Previous month days
        const firstDayOfMonth = this.monthSwitcher.AsDate.date(1);

        for (let i = firstDayOfMonth.weekday(); i > 0; i--)
        {
            const d = this.monthSwitcher.AsDate.subtract(1, "month").daysInMonth() //+ firstDayOfMonth.weekday() 
                - i + 1;
            const mn = this.monthSwitcher.AsDate.subtract(1, "month").format("MMM");

            const dayDiv = new Div("calendar-day inactive")
            /////////////    .Text(d.toString() + " " + mn);    
            this.grid.Append(dayDiv)
        }

        // Current month days
        for (let i = 1; i <= this.DaysInSelectedMonth; i++)
        {
            const dayDiv = new Div("calendar-day")
                .Append(new Div("day").Text(i.toString()))
                .OnClick(() => this.onDayClick.Call(moment(this.monthSwitcher.AsDate).date(i).toDate()));

            const ddd = moment(this.monthSwitcher.AsDate).date(i);
            if (ddd.isSame(moment(DateTimeProvider.Now), 'day'))
            {
                dayDiv.Class("today");
            }

            if (ddd.isBefore(moment(DateTimeProvider.Now), 'day'))
            {
                dayDiv.Class("inactive")
            }

            const thisDayEntries: CalendarEntry[] = this.entries.filter(event => ddd.isSame(moment(event.Date), 'date'));
            if (thisDayEntries.length > 0)
            {
                dayDiv.Append(
                    new Div().Append(
                        ...thisDayEntries.flatMap(x => x.Content?.())
                    )
                )
            }

            this.grid.Append(dayDiv);
        }

        // Next month days
        const lastDayInThisMonth = this.DaysInSelectedMonth;
        const lastWeekdayInThisMonth = this.monthSwitcher.AsDate.date(lastDayInThisMonth).weekday();
        let dayIndex = 1;
        for (let i = lastWeekdayInThisMonth + 1; i < 6 + 1; i++)
        {
            const mn = this.monthSwitcher.AsDate.add(1, "month").format("MMM");
            this.grid.Append(
                new Div("calendar-day inactive")
                //////////// .Text(dayIndex.toString() + " " + mn)
            );
            dayIndex++;
        }
    }

    private get DaysInSelectedMonth()
    {
        return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][this.monthSwitcher.month.value];
    }
}
